// src/hooks/useEmployeeUpdates.js
import { useEffect } from 'react';
import { useEmployees } from '../contexts/EmployeeContext';

/**
 * Custom hook to listen to employee updates
 * @param {Function} callback - Function to call when an employee is updated
 * @returns {Function} - Cleanup function to remove the listener
 */
export const useEmployeeUpdates = (callback) => {
    const { onEmployeeUpdate } = useEmployees();

    useEffect(() => {
        // Register the callback
        const cleanup = onEmployeeUpdate(callback);

        // Return cleanup function
        return cleanup;
    }, [onEmployeeUpdate, callback]);
};